import {postChangeLetter} from '../api/postChangeLetter';

const setPostChangeLetter = (params) => {
    return async (dispatch, getState) => {
        try {
            await postChangeLetter(params);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostChangeLetter
}